<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  card: { type: Object, required: true },
});

const route = useRoute();
const conversation = computed(() => props.card.conversations[0]);
</script>

<template>
  <section class="flex flex-col gap-3">
    <h2 class="mb-0 text-sm font-medium text-n-slate-12">
      {{ $t('CARDS.SHOW.CONVERSATION') }}
    </h2>
    <RouterLink
      v-if="conversation"
      :to="{
        name: 'inbox_conversation',
        params: {
          accountId: route.params.accountId,
          conversation_id: conversation.id,
        },
      }"
      class="flex items-center gap-3 p-3 border rounded-xl border-n-weak hover:bg-n-alpha-1"
      data-testid="card-conversation"
    >
      <span
        class="grid flex-shrink-0 rounded-lg size-9 place-content-center bg-n-alpha-2"
      >
        <span class="i-lucide-message-circle size-4 text-n-slate-11" />
      </span>
      <div class="flex flex-col flex-1 min-w-0">
        <span class="text-sm text-n-slate-12">
          #{{ conversation.id }} · {{ conversation.inbox_name }}
        </span>
        <span
          v-if="conversation.last_message"
          class="text-xs truncate text-n-slate-11"
        >
          {{ conversation.last_message }}
        </span>
      </div>
      <span class="text-xs text-n-blue-11 whitespace-nowrap">
        {{ $t('CARDS.SHOW.OPEN_CONVERSATION') }}
      </span>
    </RouterLink>
    <p v-else class="mb-0 text-sm text-n-slate-10">
      {{ $t('CARDS.SHOW.NO_CONVERSATION') }}
    </p>
  </section>
</template>
